import { render } from "./Gap.vue?vue&type=template&id=7bd64a3b&scoped=true&ts=true"
import script from "./Gap.vue?vue&type=script&lang=ts"
export * from "./Gap.vue?vue&type=script&lang=ts"

import "./Gap.vue?vue&type=style&index=0&id=7bd64a3b&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bd64a3b"]])

export default __exports__